import React from 'react'
import { Field } from 'formik'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChevronDown } from '@fortawesome/pro-regular-svg-icons/faChevronDown'

export const Select = props => {
    if (!props?.defaultValue) {
        props.options.unshift({
            label: 'Please select...',
            value: null,
            selected: true,
            disabled: true,
        })
    }

    return (
        <>
            {props?.label?.length > 0 && props?.type !== 'hidden' && (
                <p className="mb-[8px]">
                    {props.label}
                    {props.required && <sup className="text-brand-danger">*</sup>}
                </p>
            )}

            <Field name={props.name}>
                {({ field, form }) => (
                    <div className="relative">
                        <select
                            className={`appearance-none w-full py-[10px] px-[15px] rounded border border-brand-grey hover:border-brand-dark-grey text-[14px] 
                    focus:border-brand-black
                    focus:box-shadow-[0_0_0_1px_#000]
                    ${props.help ? 'mb-[5px]' : 'mb-[15px]'}`}
                            onChange={({ currentTarget }) => {
                                form.setFieldValue(field.name, currentTarget.value)
                            }}
                            defaultValue={props.defaultValue || props.options[0].value}
                            disabled={form.isSubmitting || props.disabled}
                        >
                            {props?.options?.length > 0 &&
                                props.options.map(opt => (
                                    <option
                                        key={`${field.name}_${opt.value}`}
                                        value={opt.value}
                                        label={opt.label}
                                        disabled={opt.disabled === true}
                                        selected={opt.selected === true}
                                    >
                                        {opt.label}
                                    </option>
                                ))}
                        </select>

                        <FontAwesomeIcon
                            icon={faChevronDown}
                            className="absolute right-[15px] top-[15px] text-sm"
                        />
                    </div>
                )}
            </Field>

            {props?.help?.length > 0 && props?.type !== 'hidden' && (
                <p className="text-brand-dark-grey text-[12px] mb-[15px] md:mb-[30px]">
                    {props.help}
                </p>
            )}
        </>
    )
}
